import { useEffect, useState } from 'react';
/**
 * Get size info for a given element
 *
 * @param {React.RefObject<globalThis.Element>} ref The ref to the element
 * @returns {Size}
 * @example
 * const ref = React.useRef();
 * const size = useSize(ref);
 */
export var useSize = function (ref) {
    var _a = useState({
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
    }), size = _a[0], setSize = _a[1];
    useEffect(function () {
        if (ref.current === null)
            return;
        var observer = new globalThis.ResizeObserver(function (_a) {
            var entry = _a[0];
            return setSize(entry.contentRect);
        });
        observer.observe(ref.current);
        return function () { return observer.disconnect(); };
    }, []);
    return size;
};
